import { aiChatConfigurationsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AI_CHAT_CONFIGURATIONS_ACTION_TYPE = createNamedActions('aiChatConfigurations', {
  GET_AI_CHAT_CONFIGURATIONS: 'GET_AI_CHAT_CONFIGURATIONS',
  GET_AI_CHAT_CONFIGURATION_BY_ID: 'GET_AI_CHAT_CONFIGURATION_BY_ID',
  UPDATE_AI_CHAT_CONFIGURATION: 'UPDATE_AI_CHAT_CONFIGURATION',
  CREATE_AI_CHAT_CONFIGURATION: 'CREATE_AI_CHAT_CONFIGURATION',
  DELETE_AI_CHAT_CONFIGURATION: 'DELETE_AI_CHAT_CONFIGURATION',
  GET_TEMPLATES: 'GET_TEMPLATES',
  ENABLE_TEMPLATE: 'ENABLE_TEMPLATE',
  DISABLE_TEMPLATE: 'DISABLE_TEMPLATE',
  CLONE_TEMPLATE: 'CLONE_TEMPLATE',
  RESET_AI_CHAT_CONFIGURATIONS_STATE: 'RESET_AI_CHAT_CONFIGURATIONS_STATE',
});

export const getAiChatConfigurationsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiChatConfigurationsApi.getAiChatConfigurations(params);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.GET_AI_CHAT_CONFIGURATIONS,
    payload: data,
  });
});

export const getAiChatConfigurationByIdAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await aiChatConfigurationsApi.getAiChatConfigurationById(id);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.GET_AI_CHAT_CONFIGURATION_BY_ID,
    payload: data,
  });
});

export const createAiChatConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiChatConfigurationsApi.createAiChatConfiguration(params);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.CREATE_AI_CHAT_CONFIGURATION,
    payload: data,
  });
});

export const updateAiChatConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiChatConfigurationsApi.updateAiChatConfiguration(params);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.UPDATE_AI_CHAT_CONFIGURATION,
    payload: data,
  });
});

export const deleteAiChatConfigurationAction = catchAsyncActionError(id => async dispatch => {
  await aiChatConfigurationsApi.deleteAiChatConfiguration(id);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.DELETE_AI_CHAT_CONFIGURATION,
    payload: id,
  });
});

export const getTemplatesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiChatConfigurationsApi.getTemplates(params);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.GET_TEMPLATES,
    payload: data,
  });
});

export const enableTemplateAction = catchAsyncActionError(id => async dispatch => {
  await aiChatConfigurationsApi.enableTemplate(id);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.ENABLE_TEMPLATE,
    payload: id,
  });
});

export const disableTemplateAction = catchAsyncActionError(id => async dispatch => {
  await aiChatConfigurationsApi.disableTemplate(id);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.DISABLE_TEMPLATE,
    payload: id,
  });
});

export const cloneTemplateAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await aiChatConfigurationsApi.cloneTemplate(id);

  return dispatch({
    type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.CLONE_TEMPLATE,
    payload: data,
  });
});

export const resetAiChatConfigurationsStateAction = () => ({
  type: AI_CHAT_CONFIGURATIONS_ACTION_TYPE.RESET_AI_CHAT_CONFIGURATIONS_STATE,
});
